var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimingsPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19.5px",
    height: "19.4999999px",
    viewBox: "0 0 19.5 19.4999999",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-Booking-Timings",
    transform: "translate(-68.25, -335.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:clock",
    transform: "translate(66, 333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 L12,12 L16.5,12 M21,12.0000002 C21,15.2153903 19.2846097,18.1865336 16.5,19.7942287 C13.7153903,21.4019239 10.2846097,21.4019239 7.5,19.7942287 C4.71539025,18.1865336 3,15.2153903 3,12.0000002 C3,7.02943733 7.02943733,3.00000019 12,3.00000019 C16.9705627,3.00000019 21,7.02943733 21,12.0000002 L21,12.0000002 Z",
    id: "Shape",
    stroke: "#8E06BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimingsPurple);
export default __webpack_public_path__ + "static/media/Timings-purple.c94e247b099475700a6d7afec0c69a80.svg";
export { ForwardRef as ReactComponent };